import { addStyles } from 'ethcss'
import { colors, grid, IStyles, mediaCSS } from 'theme'

const settingsStyles: IStyles = {
    telegramSettings: {
        maxWidth: 400,
        borderRadius: 5,
        border: `1px solid ${colors.grey}`,
        padding: 10,
        backgroundColor: colors.white,
    },
    title: {
        marginBottom: 24,
    },
    optionCaption: {
        marginBottom: 10,
    },
    tabs: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    tab: {
        display: 'flex',
        justifyContent: 'center',
        padding: 14,
        borderRadius: 5,
        border: `1px solid ${colors.grey}`,
        opacity: 'background 0.3s',
        width: '49%',
        cursor: 'pointer',

        '&:hover': {
            backgroundColor: colors.grey,
        },
    },
    activeTab: {
        backgroundColor: colors.grey,
    },
    qrWrapper: {
        width: 160,
        height: 160,
        borderRadius: 5,
        border: `1px solid ${colors.grey}`,
        margin: '24px auto',
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 24,
    },
    botUnavailable: {
        marginTop: 30,
        marginBottom: 24,
        textAlign: 'center',
    },
}

addStyles(settingsStyles)
export default settingsStyles
